<template>
  <div class="dynamic-content" v-html="content" />
</template>

<script>
export default {
  name: "dynamic-content",

  props: {
    content: String
  }
};
</script>

<style></style>
